import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import PageHeader from "../../components/PageHeader/PageHeader";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";

const BlockedSellerView = () => {
  const location = useLocation();
  const { item, page } = location.state ?? {};
  const navigate = useNavigate();

  console.log("item", item);

  const [form] = useState([
    { id: 1, name: "Report By", value: item?.report_by ?? "-", type: "input" },
    { id: 2, name: "Report To", value: item?.report_to ?? "-", type: "input" },
    { id: 3, name: "Enquiry ID", value: item?.order_id ?? "-", type: "input" },
    { id: 4, name: "Reason", value: item?.report_reason ?? "-", type: "input" },
    {
      id: 5,
      name: "Date & Time",
      value: item?.date_time ?? "-",
      type: "input",
    },
  ]);

  const handleAction = async (action) => {
    let payload = {
      report_id: item?.id,
      action: action,
    };
    let res = await post(URLS.BLOCKED_USERS_ACTION, payload);
    if (res?.status == "success") {
      toast.success(res?.message);
      navigate("/blocked", { state: { page: page || 1 } });
    }
  };

  return (
    <div>
      <PageHeader
        title={"Blocked Seller"}
        showBackButton={true}
        onBackClick={() => navigate("/blocked", { state: { page: page || 1 } })}
      />

      <div className="form-grid">
        {form.map((i) => {
          return (
            <div className="form-item" key={i.id}>
              <div className="form-group">
                <label>{i.name}</label>
                {i.id == 4 ? (
                  <textarea value={i.value || ""} readOnly rows={1} />
                ) : (
                  <input type="text" value={i.value || ""} readOnly />
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div className="form-actions">
        <button className="btn-edit" onClick={() => handleAction("reject")}>
          Reject
        </button>
        <button className="btn-save" onClick={() => handleAction("approve")}>
          Approve
        </button>
      </div>
    </div>
  );
};

export default BlockedSellerView;
